const getListOfAppliedFilters = (allQueryStrings: any) => {
  const appliedBqFilters = allQueryStrings["bq"];
  const appliedMissingMileage = allQueryStrings["missingMileage"];
  const appliedAwaitingAppraisal = allQueryStrings["awaitingAppraisal"];

  if (
    !appliedBqFilters &&
    !appliedMissingMileage &&
    !appliedAwaitingAppraisal
  ) {
    return [];
  }
  const queryParts =
    appliedBqFilters?.split("|")?.filter((item) => item.length > 0) || [];

  const listOfChips = queryParts
    ?.map((item) => {
      const categoryKey = item.split(":")[0];
      const subFilters = item.split(":")[1].split(",");

      const list = subFilters.map((val) => {
        const obj = { categoryKey: categoryKey, filterKey: val };
        return obj;
      });

      return list;
    })
    .flat();

  if (appliedMissingMileage) {
    listOfChips.push({ categoryKey: "missingMileage", filterKey: "false" });
  }

  if (appliedAwaitingAppraisal) {
    listOfChips.push({ categoryKey: "awaitingAppraisal", filterKey: "false" });
  }

  return listOfChips;
};

export default getListOfAppliedFilters;
